import { render, staticRenderFns } from "./createinterface.vue?vue&type=template&id=476b5562&scoped=true"
import script from "./createinterface.vue?vue&type=script&lang=js"
export * from "./createinterface.vue?vue&type=script&lang=js"
import style0 from "./createinterface.vue?vue&type=style&index=0&id=476b5562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b5562",
  null
  
)

export default component.exports